<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <h3>Bet Sizing Calculator</h3>
        <div class="two-column">
          <div class="column">
            <div v-if="errors.any()" id="feedback">
              <p v-if="errors.has('bankroll')" class="error wrong_name error-box">
                Please enter a bankroll
              </p>
              <p v-if="errors.has('odds')" class="error wrong_email error-box">
                {{ errors.first('odds') }}
              </p>
              <p v-if="errors.has('edge')" class="error wrong_message error-box">
                {{ errors.first('edge') }}
              </p>
            </div>
            <form>
              <div class="row">
                <div class="input-group">
                  <label for="bankroll">Bankroll:</label>
                  <input
                    ref="bankroll"
                    v-model="bankroll"
                    v-validate="'required'"
                    type="number"
                    name="bankroll"
                  />
                </div>
                <div class="input-group">
                  <label for="odds">American Odds:</label>
                  <input
                    ref="odds"
                    v-model="odds"
                    v-validate="'required|american_odds'"
                    type="text"
                    name="odds"
                    data-vv-delay="4000"
                  />
                </div>
              </div>
              <div class="row" style="margin-top:20px;">
                <div class="input-group">
                  <label for="risk">Edge %:</label>
                  <input
                    ref="edge"
                    v-model="edge"
                    v-validate="'required|decimal'"
                    type="number"
                    name="edge"
                  />
                </div>
              </div>
              <div class="row">
                <div class="radio-group">
                  <div v-for="multiplier in multipliers" :key="multiplier">
                    <label>
                      <input v-model="selectedMultiplier" type="radio" :value="multiplier" @change="multiplierChange" />
                      {{ multiplier }}
                    </label>
                  </div>
                </div>
              </div>
              <p>
                <input
                  type="submit"
                  value="Calculate Optimal Bet Size"
                  name="submitButton"
                  class="big-btn grey"
                  @click.prevent="calculate"
                />
              </p>
            </form>
          </div>
          <div class="column" style="min-width:100px;">
            <h4 v-if="showOptimalBetSize">
              Optimal Bet Size: ${{ optimal.betSize }}
            </h4>
            <p v-if="showOptimalBetSize">
              It is recommended that you bet approximately <b>{{ optimal.percentage }}</b> of your bankroll on this particular selection.
            </p>
            <p v-if="showOptimalBetSize">
              <b>Note:</b> This is a general recommendation for {{ selectedMultiplier }} bet sizing and should be adjusted based on your own risk tolerance and confidence in the selection.
            </p>
          </div>
        </div>
      </div>
      <div id="sidebar">
        <adsense
          ad-client="ca-pub-8213113866781504"
          ad-slot="7997332272"
          ad-style="display:inline-block;width:250px;height:250px"
          ad-format="auto"
        >
        </adsense>
      </div>
    </div>
  </div>
</template>

<script>
import Adsense from "../../components/adsense.vue";
import ToolRepository from '../../data/tool.repository.js'

export default {
  components: {
    adsense: Adsense
  },
  data () {
    return {
      multipliers: ["Conservative", "Standard", "Aggressive"],
      selectedMultiplier: "Standard",
      bankroll: 1000,
      odds: "-150",
      edge: "5",
      optimal: {betSize: 0, percentage: 0},
    }
  },
  computed: {
    currentUser () {
      return this.$store.state.currentUser
    },
    showOptimalBetSize() {
      console.log("updating optimal bet size ", this.optimal.betSize)
      console.log(this.optimal.betSize > 0)
      return this.optimal.betSize > 0
    }
  },
  methods: {
    calculate() {
      if (!this.currentUser || !this.currentUser.id) {
        this.$root.$refs.toastr.w('Please log in or register to use the bet calculator')
        return
      }
      return this.$validator.validateAll().then((result) => {
        if (result) {
          const multiplier = this.multipliers.indexOf(this.selectedMultiplier)
          return ToolRepository.size({bankroll: this.bankroll, line: Number(this.odds), edge: this.edge / 100, multiplier}).then((response) => {
            this.optimal = Object.assign({}, this.optimal, {betSize: response.optimal_bet, percentage: response.optimal_percentage})
            console.log(this.optimal.betSize)
          })
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    multiplierChange() {
      this.optimal = Object.assign({}, this.optimal, {betSize: 0, percentage: 0})
    }
  }
}
</script>

<style lang="css" scoped>
.two-column {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  align-items: start;
}
.column {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.row {
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-bottom: 16px;
}
.input-group {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.input-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 6px;
  color: #2d3748;
  font-size: 14px;
}

.input-group input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #cbd5e0;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.input-group input:focus {
  outline: none;
  border-color: #3182ce;
}

.radio-group {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.radio-group label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #2d3748;
  cursor: pointer;
}

.radio-group input[type="radio"] {
  cursor: pointer;
}

h4 {
  letter-spacing: 1px;
}

.big-btn {
  margin-top: 8px;
}

@media (max-width: 768px) {
  .two-column {
    grid-template-columns: 1fr;
  }

  .row {
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// BetSizing.vue?014290fc